declare global {
  interface Window { subscribers: any; }
}

window.subscribers = window.subscribers || {};
const subscribers = window.subscribers;

const pubSub = {
  publish(event: any, data?: any) {
    if (!subscribers[event]) return;
    subscribers[event].forEach((subscriberCallback: any) =>
      subscriberCallback(data)
    );
  },
  subscribe(event: any, callback: any) {
    if (!subscribers[event]) {
      subscribers[event] = [];
    }
    subscribers[event].push(callback);
    return () => {
      subscribers[event] = [];
    };
  },
};

const EVENTS = {
  ORGANIZATIONS_LIST: 'ORGANIZATIONS_LIST',
  DEVICES_LIST: 'DEVICES_LIST',
  DEVICES_ON_LINKED: 'DEVICES_ON_LINKED',
  PROGRESS: 'PROGRESS',
  ADD_ORGANIZATION: 'ADD_ORGANIZATION',
  ERROR: 'ERROR',
  PP_ERROR_ORGANIZATION_DUP: 'PP_ERROR_ORGANIZATION_DUP',
  SUCCESS: 'SUCCESS',
  DISPLAY_NAME_CHANGED: 'DISPLAY_NAME_CHANGED',
  APP_LIST_REFRESH: 'APP_LIST_REFRESH',
  BILLING_MODE_UPDATE: 'BILLING_MODE_UPDATE'
}

export default pubSub;
export { EVENTS }
